import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

export default function Testimonials({ testimonials }) {
  return (
    <div className="mt-16 flex justify-center items-center flex-col">
      <h2 className="font-bold text-3xl mb-10">
        What our users are saying
      </h2>

      <div className="w-full max-w-2xl px-6">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 4000 }}
          loop={true}
        >
          {testimonials.map((feedback, index) => (
            <SwiperSlide key={index}>
              <div className="bg-white shadow-lg rounded-2xl p-8 text-center">
                <p className="text-blue-400 font-extrabold text-5xl leading-none">
                  "
                </p>
                <p className="text-xl md:text-2xl mt-4">
                  {feedback.testimonial}
                </p>
                <p className="text-lg font-bold mt-6">
                  - {feedback.name} ({feedback.location})
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
